





















































































































































import { Component } from "vue-property-decorator";
import { IMapLayer } from "@/components/map/types";
import { L } from "@/common/filters";
import MapService from "./map.service.class";
import TreeListUI from "@/components/shared/TreeListUI.vue";

@Component({
  components: {
    'v-tree-list': TreeListUI
  }
})
export default class MapLayers extends MapService {
  showAddUserLayer: boolean = false;
 
  created() {
    this.$map = this.data.$map;
    this.mapLayerStore = this.data.mapStore;
    let n = this.mapLayerStore.length - 1;
    this.mapLayer = this.mapLayerStore[n];
  }

  toggleToc(toc) {
    this.$emit('iWantToDo', {
      name: 'toggle_toc',
      data: toc
    });
  }
  
  get Backdrop() : boolean {
    return this.$store.getters.ShowBackdrop;
  }
  
  set Backdrop(show:boolean) {
    this.$store.commit('notifyChange', {
      ShowBackdrop: show
    });
  }

  accept() {
    let layer:IMapLayer = this.createLayer();
    layer.mapSources[0].visible = true;
    layer.actions = [{
      do: this.removeUserLayer,
      type: "button",
      width: 'auto',
      icon: 'mdi-delete-circle-outline'
    }];
    this.insertLayer(layer);
    this.Backdrop = false;
    this.showAddUserLayer = false;
    this.resetForm();
  }

  removeUserLayer(layer) {
    this.$store.commit('notifyChange', {
      Dialog: {
        Type: 'info',
        Title: 'attention',
        Message: L('sAreYouGoingToDeleteThisLayer',[layer.title]),
        OkText: 'yes',
        CancelText: 'no',
        show: true,
        OnClose: (answer) => {
          if (answer=='ok') {
            this.doRemoveUserLayer(layer);
          }
          return true; // close dialog
        }
      }
    });
  }

  doRemoveUserLayer(layer) {
    let m = layer.mapSources[0].nativeLayer;
    let mLayers = this.$map.map.NativeMap.getLayers();
    mLayers.remove(m);
    let i = this.mapLayer.children.indexOf(layer);
    this.mapLayer.children.splice(i,1);
  }

  cancel() {
    this.Backdrop = false;
    this.showAddUserLayer = false;
    this.resetForm();
  }
}
